var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'atom-specs-info': true, active: _vm.isActive },on:{"click":_vm.handleClick}},[_c('p',[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }